import { useState } from 'react'
import { t } from '@lingui/core/macro'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import TextField from '@mui/material/TextField'
import { CvsAutoComplete } from '@components'

export const Random = ({ segment, updateSegment }) => {
  const [updatedSegment, setUpdatedSegment] = useState({ ...segment })

  const onUpdate = () => {
    updateSegment(updatedSegment)
  }

  return (
    <div style={{ padding: 12, paddingTop: 24 }}>
      <div>
        <TextField
          variant="outlined"
          style={{ width: '100%' }}
          label={t`Length of random`}
          type="number"
          value={updatedSegment.max_length}
          onChange={e => {
            const val = parseInt(e.target.value)
            setUpdatedSegment({ ...updatedSegment, max_length: val })
          }}
        />
      </div>
      <div style={{ marginTop: 12 }}>
        <FormControlLabel
          style={{ margin: 0, height: 40 }}
          control={
            <Checkbox
              checked={updatedSegment.random.include_numeric}
              onChange={(e, newVal) => {
                setUpdatedSegment({
                  ...updatedSegment,
                  random: { ...updatedSegment.random, include_numeric: newVal },
                })
              }}
              value={updatedSegment.random.include_numeric}
              style={{ padding: 2 }}
              color="secondary"
            />
          }
          label={t`Use numeric digits (0-9)`}
        />
      </div>
      <div style={{}}>
        <FormControlLabel
          style={{ margin: 0, height: 40 }}
          control={
            <Checkbox
              checked={updatedSegment.random.include_uppercase}
              onChange={(e, newVal) => {
                setUpdatedSegment({
                  ...updatedSegment,
                  random: { ...updatedSegment.random, include_uppercase: newVal },
                })
              }}
              value={updatedSegment.random.include_uppercase}
              style={{ padding: 2 }}
              color="secondary"
            />
          }
          label={t`Use uppercase letters (A-Z)`}
        />
      </div>
      <div style={{}}>
        <FormControlLabel
          style={{ margin: 0, height: 40 }}
          control={
            <Checkbox
              checked={updatedSegment.random.include_lowercase}
              onChange={(e, newVal) => {
                setUpdatedSegment({
                  ...updatedSegment,
                  random: { ...updatedSegment.random, include_lowercase: newVal },
                })
              }}
              value={updatedSegment.random.include_lowercase}
              style={{ padding: 2 }}
              color="secondary"
            />
          }
          label={t`Use lowercase letters (A-Z)`}
        />
      </div>
      <div style={{ marginTop: 8 }}>
        <CvsAutoComplete
          style={{ width: '100%', margin: 0 }}
          label={t`Frequency`}
          options={[
            { value: 'row', label: t`Once on every row` },
            { value: 'session', label: t`Once per session` },
          ]}
          selected={updatedSegment.random.frequency}
          onSelected={item => {
            setUpdatedSegment({
              ...updatedSegment,
              random: { ...updatedSegment.random, frequency: item },
            })
          }}
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <Button
          variant="contained"
          disabled={updatedSegment.max_length < 6}
          color="secondary"
          onClick={onUpdate}
          style={{ width: '100%' }}
        >
          {t`Done`}
        </Button>
      </div>
    </div>
  )
}
